// NotFound.js

import React from 'react';
import texts from '../constants/views/notFoundText';
const NotFound = () => {
  return <div style={{ width: "100%",display: "flex",justifyContent: "center",alignItems: "center"}}>{texts.notFound}</div>;
};

export default NotFound;
